import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { usePayoffRequestStore } from '../hooks/usePayoffRequestStore';
import { PayoffKeyLoanInformation } from './payoffKeyLoanInformation';
import { LoanPayoffs } from './loanPayoffs';

const useStyles = makeStyles(theme => ({
  gridContainer: {
    padding: '24px 8px',
  },
}));

export const PayoffDashboardV3 = observer(({ loanId }: { loanId: string }) => {
  const classes = useStyles();

  const { payoffRequestStore } = usePayoffRequestStore();

  useEffect(() => {
    return () => {
      payoffRequestStore.setIsForeclosure(false);
    };
  }, []);

  return (
    <>
      <Grid direction="row" spacing={3} xs={12} md={12} style={{ margin: 0 }}>
        <Grid container spacing={2} style={{
          margin: 0
        }}>
          <Grid item xs={12}>
            <PayoffKeyLoanInformation />
          </Grid>
        </Grid >
        <Grid container spacing={2} style={{
          margin: 0
        }}>
          <Grid item xs={12} md={12} className={classes.gridContainer}>
            <LoanPayoffs loanId={loanId} />
          </Grid>
        </Grid>
      </ Grid>
    </>
  );
});